// extracted by mini-css-extract-plugin
module.exports = {"layout":"BonusWithGamesPopup__layout--aF6","game":"BonusWithGamesPopup__game--hRK"};